var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92293 10.9942C3.75 11.8636 3.75 12.9091 3.75 15C3.75 17.0909 3.75 18.1364 3.92293 19.0058C4.63309 22.576 7.42397 25.3669 10.9942 26.0771C11.8636 26.25 12.9091 26.25 15 26.25H20.625C23.0906 26.25 24.3234 26.25 25.1532 25.569C25.3051 25.4444 25.4444 25.3051 25.569 25.1532C26.25 24.3234 26.25 23.0906 26.25 20.625V15C26.25 12.9091 26.25 11.8636 26.0771 10.9942C25.3669 7.42397 22.576 4.63309 19.0058 3.92293C18.1364 3.75 17.0909 3.75 15 3.75C12.9091 3.75 11.8636 3.75 10.9942 3.92293C7.42397 4.63309 4.63309 7.42397 3.92293 10.9942ZM10.25 13.75C10.25 13.1977 10.6977 12.75 11.25 12.75H18.75C19.3023 12.75 19.75 13.1977 19.75 13.75C19.75 14.3023 19.3023 14.75 18.75 14.75H11.25C10.6977 14.75 10.25 14.3023 10.25 13.75ZM14 18.75C14 18.1977 14.4477 17.75 15 17.75H18.75C19.3023 17.75 19.75 18.1977 19.75 18.75C19.75 19.3023 19.3023 19.75 18.75 19.75H15C14.4477 19.75 14 19.3023 14 18.75Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFill);
export default __webpack_public_path__ + "static/media/Chat_fill.2d1fc3c0041f7e01c1ec1e104f8481ad.svg";
export { ForwardRef as ReactComponent };